var colors = require('../Colors.js');

module.exports = {
  label: 'Material',
  children: {
    ZI: {
      label: 'Zirkon',
      children: {
        BredentLuxor: {
          label: 'Bredent Luxor Z',
          tooltip: 'Festigkeit: ≥ 1.100 MPa im cervicalen Bereich und ≥ 750 MPa im höheren incisalen Bereich. Geeignet für mehrspannige Brücken bis 3 Brückenglieder.',
          tooltipSize: 'xlarge',
          itemnum: '2.1.1',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO', 'V', 'I', 'T1'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'Bleach']),
          }
        },
        CubeXML: {
          label: 'DD cubeX ML',
          tooltip: 'Festigkeit: 700 ± 100 Mpa. Veneers, Inlays, Onlays, Anatomisch reduzierte Krone, Vollanatomische Krone Frontzahn, Vollanatomische Krone Seitenzahn, Anatomisch reduzierte Brücke (bis 1 Brückenglied) und Vollanatomische Brücke (bis 1 Brückenglied)',
          tooltipSize: 'xlarge',
          itemnum: '2.1.2',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'KMH', 'V', 'I'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'Bleach']),
          }
        },
        NaceraPearl: {
          label: 'DD Nacera® Pearl Natural',
          tooltip: 'Festigkeit: 1050 ± 150 MPa zervikal. Veneers, Inlays, Onlays, Anatomisch reduzierte Krone, Vollanatomische Krone Frontzahn, Vollanatomische Krone Seitenzahn, Anatomisch reduzierte Brücke (bis 3 Brückenglieder), Anatomisch reduzierte Brücke (bis 14 Glieder), Vollanatomische Brücke (bis 3 Brückenglieder) und Vollanatomische Brücke (bis 14 Glieder)',
          tooltipSize: 'xlarge',
          itemnum: '2.1.3',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO', 'V', 'I', 'T1'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'OM2', 'OM3', 'Stellar White']),
          }
        },
        DDZXColor: {
          label: 'DD Bio ZX² color',
          tooltip: 'Festigkeit: 1150 ± 150 Mpa. Anatomisch reduzierte Krone, Vollanatomische Krone Seitenzahn, Primärteleskop, Anatomisch reduzierte Brücke (bis 3 Brückenglieder), Anatomisch reduzierte Brücke (bis 14 Glieder), Vollanatomische Brücke (bis 3 Brückenglieder), Vollanatomische Brücke (bis 14 Glieder), Hybrid-Abutment und Steg',
          tooltipSize: 'xlarge',
          itemnum: '2.1.4',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO', 'V', 'I', 'T1'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4']),
          }
        },
        DDZWIsoColor: {
          label: 'DD Bio ZW iso color',
          tooltip: 'Festigkeit: 1150 ± 200 MPa. Anatomisch reduzierte Krone, Primärteleskop, Anatomisch reduzierte Brücke (bis 3 Glieder), Anatomisch reduzierte Brücke (bis 14 Glieder) und Hybrid-Abutment',
          tooltipSize: 'xlarge',
          itemnum: '2.1.7',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO', 'V', 'I', 'T1'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'B1', 'B2', 'C1', 'D2']),
          }
        },
        Geschiebe: {
          label: 'Geschiebe',
          itemnum: '2.1.5',
          indications: ['KO', 'KVO', 'KMO']
        },
        Teilungsgeschiebe: {
          label: 'Teilungsgeschiebe',
          itemnum: '2.1.6',
          indications: ['KO', 'KVO', 'KMO', 'KO2', 'KVO2', 'KMO2']
        },
      }
    },
    CoCr_milled: {
      label: 'CoCr gefräst',
      children: {
        "Gerüst zum Verblenden": {
          label: 'Gerüst zum Verblenden',
          itemnum: '2.2.1',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KH', 'KVO', 'KMH', 'KMO']
        },
        "Gerüst teil- oder vollanatomisch": {
          label: 'Gerüst teil- oder vollanatomisch',
          itemnum: '2.2.2',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KH', 'KVO', 'KMH', 'KMO']
        },
        Primärteleskope: {
          label: 'Primärteleskop',
          itemnum: '2.2.3',
          indications: ['T1', 'TV', 'TM', 'T2'],
        },
        "TK-Soft": {
          label: 'TK-Soft',
          itemnum: '2.2.4',
          indications: ['T2V', 'T2M', 'ST', 'STM', 'STV'],
        },
        Abutment: {
          label: 'Abutment',
          itemnum: '2.2.5',
          indications: ['ST', 'STM', 'STV', 'K', 'KM', 'KV', 'B', 'BV', 'BM'],
        },
        "Modellguss gefräst": {
          label: 'Modellguss gefräst',
          itemnum: '2.2.6',
          indications: ['MOG'],
        },
        Sekundärteleskope: {
          label: 'Sekundärteleskop',
          itemnum: '2.2.7',
          indications: ['TM', 'T2M', 'T2V', 'T', 'T2', 'TV', 'ST', 'STV', 'STM'],
        },
        "Retentionen je 1 Quadrant": {
          label: 'Retentionen je 1 Quadrant',
          itemnum: '2.2.8',
          indications: ['R'],
        },
        "Löt-/Klebeverbinder je Sekundärteleskop": {
          label: 'Löt-/Klebeverbinder je Sekundärteleskop',
          itemnum: '2.2.9',
          indications: ['R'],
        },
        Tertiärkonstruktion: {
          label: 'Tertiärkonstruktion',
          itemnum: '2.2.10',
          indications: ['TER'],
        },
        Stiftaufbau: {
          label: 'Stiftaufbau',
          itemnum: '2.2.11',
          indications: ['STI'],
        },
        "Steg auf Klebebasen": {
          label: 'Steg auf Klebebasen',
          indications: ['I', 'EO', 'O'],
          children: {
            x2: {
              label: '2 Implantate',
              itemnum: '2.2.12',
            },
            x3: {
              label: '3 Implantate',
              itemnum: '2.2.13',
            },
            x4: {
              label: '4 Implantate',
              itemnum: '2.2.14',
            },
            x5: {
              label: '5 Implantate',
              itemnum: '2.2.15',
            },
            x6: {
              label: '6 Implantate',
              itemnum: '2.2.16',
            },
            x7: {
              label: '7 Implantate',
              itemnum: '2.2.17',
            },
            x8: {
              label: '8 Implantate',
              itemnum: '2.2.18',
            },
          }
        },
        Stegüberwurf: {
          label: 'Stegüberwurf mit Halteelementen',
          itemnum: '2.2.19',
          indications: ['STE'],
        },
        Geschiebe: {
          label: 'Geschiebe',
          itemnum: '2.2.20',
          indications: ['O'],
        },
        Teilungsgeschiebe: {
          label: 'Teilungsgeschiebe',
          itemnum: '2.2.21',
          indications: ['O'],
        },
        Implantatbrücke: {
          label: 'Implantatbrücke',
          indications: ['I', 'O', 'B', 'BV', 'BM'],
          children: {
            x2: {
              label: '2 Implantate',
              itemnum: '2.2.22',
            },
            x3: {
              label: '3 Implantate',
              itemnum: '2.2.23',
            },
            x4: {
              label: '4 Implantate',
              itemnum: '2.2.24',
            },
            x5: {
              label: '5 Implantate',
              itemnum: '2.2.25',
            },
            x6: {
              label: '6 Implantate',
              itemnum: '2.2.26',
            },
          }
        },
        "Steg mit Anschlüssen": {
          label: 'Steg mit Anschlüssen',
          indications: ['I', 'EO', 'O'],
          children: {
            x2: {
              label: 'Steg mit 2 Anschlüssen',
              itemnum: '2.2.27',
            },
            x3: {
              label: 'Steg mit 3 Anschlüssen',
              itemnum: '2.2.28',
            },
            x4: {
              label: 'Steg mit 4 Anschlüssen',
              itemnum: '2.2.29',
            },
            x5: {
              label: 'Steg mit 5 Anschlüssen',
              itemnum: '2.2.30',
            },
            x6: {
              label: 'Steg mit 6 Anschlüssen',
              itemnum: '2.2.31',
            },
            x7: {
              label: 'Steg mit 7 Anschlüssen',
              itemnum: '2.2.32',
            },
            x8: {
              label: 'Steg mit 8 Anschlüssen',
              itemnum: '2.2.33',
            },
          }
        },
      }
    },
    LaserMelting: {
      label: 'Laser Melting',
      properties: {
        mat: {
          type: 'html',
          value: 'Material: remanium star® powder',
        },
      },
      children: {
        "Gerüst zum Verblenden": {
          label: 'Gerüst zum Verblenden',
          itemnum: '2.3.1',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KH', 'KVO', 'KMH', 'KMO'],
        },
        "Gerüst teil- oder vollanatomisch": {
          label: 'Gerüst teil- oder vollanatomisch',
          itemnum: '2.3.2',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KH', 'KVO', 'KMH', 'KMO'],
        },
        Primärteleskope: {
          label: 'Primärteleskope',
          itemnum: '2.3.3',
          indications: ['T1', 'TV', 'TM', 'T2']
        },
        Sekundärteleskope: {
          label: 'Sekundärteleskope',
          itemnum: '2.3.4',
          indications: ['TM', 'T2M', 'T2V', 'T', 'T2', 'TV', 'ST', 'STV', 'STM'],
        },
        "Retentionen je  Quadrant": {
          label: 'CoCr Retentionen je  Quadrant',
          itemnum: '2.3.5',
          indications: ['R']
        },
        "Löt-/Klebeverbinder je Sekundärteleskop": {
          label: 'Löt-/Klebeverbinder je Sekundärteleskop',
          itemnum: '2.3.6',
          indications: ['R']
        },
        Geschiebe: {
          label: 'Geschiebe',
          itemnum: '2.3.7',
          indications: ['O']
        },
        Teilungsgeschiebe: {
          label: 'Teilungsgeschiebe',
          itemnum: '2.3.8',
          indications: ['O']
        },
        Tertiärkonstruktion: {
          label: 'Tertiärkonstruktion',
          itemnum: '2.3.9',
          indications: ['TER']
        },
        "Modellguss matt": {
          label: 'Modellguss matt',
          itemnum: '2.3.10',
          indications: ['MOG']
        },
        "Modellguss glänzend": {
          label: 'Modellguss glänzend',
          itemnum: '2.3.11',
          indications: ['MOG']
        },
        "Klammermodellguss matt": {
          label: 'Klammermodellguss matt',
          itemnum: '2.3.12',
          indications: ['MOG']
        },
        "Klammermodellguss glänzend": {
          label: 'Klammermodellguss glänzend',
          itemnum: '2.3.13',
          indications: ['MOG']
        },
        Stiftaufbau: {
          label: 'Stiftaufbau',
          itemnum: '2.3.14',
          indications: ['STI'],
        },
        "TK-Soft": {
          label: 'TK-Soft',
          itemnum: '2.3.15',
          indications: ['T2V', 'T2M', 'ST', 'STM', 'STV'],
        },
        Stegüberwurf: {
          label: 'Stegüberwurf mit Halteelementen',
          itemnum: '2.3.16',
          indications: ['STE']
        },
        "Steg auf Klebebasen": {
          label: 'Steg auf Klebebasen',
          indications: ['I', 'EO', 'O'],
          children: {
            x2: {
              label: '2 Implantate',
              itemnum: '2.2.17',
            },
            x3: {
              label: '3 Implantate',
              itemnum: '2.2.18',
            },
            x4: {
              label: '4 Implantate',
              itemnum: '2.2.19',
            },
            x5: {
              label: '5 Implantate',
              itemnum: '2.2.20',
            },
            x6: {
              label: '6 Implantate',
              itemnum: '2.2.21',
            },
            x7: {
              label: '7 Implantate',
              itemnum: '2.2.22',
            },
            x8: {
              label: '8 Implantate',
              itemnum: '2.2.23',
            },
          }
        },
        Retainer: {
          label: 'Retainer',
          itemnum: '2.2.24',
          indications: ['RET'],
        },
      }
    },
    ks_3d: {
      label: 'Kunststoff 3D-Druck',
      children: {
        /*"Modell je Kiefer": {
          label: 'Modell je Kiefer',
          itemnum: '2.5.1',
        },
        "Modell je Quadrant": {
          label: 'Modell je Quadrant',
          itemnum: '2.5.2',
        },
        Zahnfleischmaske: {
          label: 'Zahnfleischmaske',
          itemnum: '2.5.3',
        },
        Stumpf: {
          label: 'Stumpf zusätzlich',
          itemnum: '2.5.4',
        },*/
        Löffel: {
          label: 'Löffel',
          itemnum: '2.5.5',
          indications: ['L']
        },
        Modellguss: {
          label: 'Modellguss',
          itemnum: '2.5.6',
          indications: ['MOG']
        },
        Gerüst: {
          label: 'Gerüst',
          itemnum: '2.5.7',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO']
        },
        Schiene: {
          label: 'Schiene',
          itemnum: '2.5.8',
          indications: ['S']
        },
        /*"Indiv. Artikulator": {
          label: 'Indiv. Artikulator',
          itemnum: '2.5.9',
        },*/
      },
    },
    ks_milled: {
      label: 'Kunststoff gefräst',
      children: {
        "Pmma Schiene": {
          label: 'Pmma Schiene',
          itemnum: '2.4.1',
          indications: ['S']
        },
        "Bego E-splint Schiene": {
          label: 'Bego E-splint Schiene',
          itemnum: '2.4.2',
          indications: ['S']
        },
        "Eldy Schiene": {
          label: 'Eldy Schiene',
          itemnum: '2.4.3',
          indications: ['S']
        },
        "Pmma Schiene zahnfarbend": {
          label: 'Pmma Schiene zahnfarbend',
          itemnum: '2.4.4',
          indications: ['S']
        },
        "Astron® CLEARsplint® Schiene": {
          label: 'Astron® CLEARsplint® Schiene',
          itemnum: '2.4.21',
          indications: ['S']
        },
        "Eldy Invisible Denture OK": {
          label: 'Eldy Invisible Denture, OK',
          itemnum: '2.4.5',
          indications: ['MOG']
        },
        "Eldy Invisible Denture je Quadrant": {
          label: 'Eldy Invisible Denture je Quadrant',
          itemnum: '2.4.6',
          indications: ['MOG']
        },
        "Pmma Gerüst einfarbig": {
          label: 'Pmma Gerüst einfarbig',
          itemnum: '2.4.7',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO']
        },
        "Pmma Gerüst mit Farbverlauf": {
          label: 'Pmma Gerüst mit Farbverlauf',
          itemnum: '2.4.8',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO']
        },
        "Pmma Geschiebe": {
          label: 'Pmma Geschiebe',
          itemnum: '2.4.9',
          indications: ['O']
        },
        "BioHPP Sky elegance prefab": {
          label: 'BioHPP Sky elegance prefab',
          itemnum: '2.4.10',
          indications: ['I']
        },
        "Ivotion Dent Gerüst": {
          label: 'Ivotion Dent Gerüst',
          itemnum: '2.4.11',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'KMH']
        },
        "Eldy Gerüst einfarbig": {
          label: 'Eldy Gerüst einfarbig',
          itemnum: '2.4.12',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'KMH']
        },
        "Eldy Gerüst mit Farbverlauf": {
          label: 'Eldy Gerüst mit Farbverlauf',
          itemnum: '2.4.13',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'KMH']
        },
        "BioHPP Sekundärteleskope": {
          label: 'BioHPP Sekundärteleskope',
          itemnum: '2.4.14',
          indications: ['TM', 'TV', 'T2V', 'T2M', 'ST', 'STM', 'STV', 'T']
        },
        "BioHPP Modellguss": {
          label: 'BioHPP Modellguss',
          itemnum: '2.4.15',
          indications: ['MOG']
        },
        "BioHPP Gerüst": {
          label: 'BioHPP Gerüst',
          itemnum: '2.4.16',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'KMH']
        },
        "BioHPP TK-Soft": {
          label: 'BioHPP TK-Soft',
          itemnum: '2.4.17',
          indications: ['T2V', 'T2M', 'ST', 'STM', 'STV']
        },
        "BioHPP Retentionen je Quadrant": {
          label: 'BioHPP Retentionen je Quadrant',
          itemnum: '2.4.18',
          indications: ['R']
        },
        "BioHPP Klebeverbinder je Sekundärteleskop": {
          label: 'BioHPP Klebeverbinder je Sekundärteleskop',
          itemnum: '2.4.19',
          indications: ['R']
        },
        "Eldy Invisible Denture": {
          label: 'Eldy Invisible Denture, UK',
          itemnum: '2.4.20',
          indications: ['MOG']
        },
      }
    },
    glas: {
      label: 'Glaskeramik',
      children: {
        emax_LT: {
          label: 'IPS e.max CAD, LT',
          itemnum: '2.6.3',
          indications: ['K', 'KV', 'KM', 'V', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'BL1', 'BL2', 'BL3', 'BL4']),
          }
        },
        emax_MT: {
          label: 'IPS e.max CAD, MT',
          itemnum: '2.6.2',
          indications: ['K', 'KV', 'KM', 'V', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'B1', 'BL2', 'BL3', 'BL4']),
          }
        },
        emax_HT: {
          label: 'IPS e.max CAD, HT',
          itemnum: '2.6.1',
          indications: ['K', 'KV', 'KM', 'V', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'BL1', 'BL2', 'BL3', 'BL4']),
          }
        },
        emax_MO: {
          label: 'IPS e.max CAD, MO',
          itemnum: '2.6.4',
          indications: ['K', 'KV', 'KM', 'V', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH'],
          properties: {
            color: colors(['MO 0', 'MO 1', 'MO 2', 'MO 3', 'MO 4']),
          }
        },
        amber: {
          label: 'Amber® Mill CAD/CAM',
          itemnum: '2.6.5',
          indications: ['K', 'KV', 'KM', 'V', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'W1', 'W2', 'W3', 'W4']),
          }
        },
      }
    },
    ti: {
      label: 'Titan gefräst',
      children: {
        Gerüst: {
          label: 'Gerüst',
          itemnum: '2.7.1',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO']
        },
        Primärteleskop: {
          label: 'Primärteleskop',
          itemnum: '2.7.2',
          indications: ['T1', 'TV', 'TM']
        },
        Sekundärteleskop: {
          label: 'Sekundärteleskop',
          itemnum: '2.7.3',
          indications: ['TM', 'T2M', 'T2V', 'T']
        },
        Retentionen: {
          label: 'Retentionen je Quadrant',
          itemnum: '2.7.4',
          indications: ['R']
        },
        "Löt-/Klebeverbinder je Sekundärteleskop": {
          label: 'Löt-/Klebeverbinder je Sekundärteleskop',
          itemnum: '2.7.5',
          indications: ['R']
        },
        Modellguss: {
          label: 'Modellguss',
          itemnum: '2.7.6',
          indications: ['MOG']
        },
        "TK-Soft": {
          label: 'TK-Soft',
          itemnum: '2.7.7',
          indications: ['T2V', 'T2M', 'ST', 'STM', 'STV']
        },        
        "Multiunit all on": {
          label: 'Multiunit all on …',
          indications: ['I', 'EO', 'O'],
          children: (() => {
            let obj = {};
            for (let c = 8; c < 15; c++)
              obj['x' + (c - 6)] = {
                label: 'Multiunit all on ' + (c - 6),
                itemnum: '2.7.' + c,
              };
            return obj;
          })(),
        },
        "Abutment Medentika": {
          label: 'Abutment Medentika',
          itemnum: '2.7.15',
          indications: ['I'],
        },
        "Abutment Dental Direkt": {
          label: 'Abutment Dental Direkt',
          itemnum: '2.7.16',
          indications: ['I'],
        },
        "Abutment Straumann original": {
          label: 'Abutment Straumann original',
          itemnum: '2.7.17',
          indications: ['I'],
        },
        "Abutment SIC": {
          label: 'Abutment SIC',
          itemnum: '2.7.18',
          indications: ['I'],
        },
        "Abutment copaSky": {
          label: 'Abutment copaSky',
          itemnum: '2.7.19',
          indications: ['I'],
        },
      }
    },
    wax: {
      label: 'Wachs',
      children: {
        Gerüst: {
          label: 'Gerüst',
          itemnum: '2.8.1',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO', 'V', 'T1']
        },
      }
    }
  }
}
